<template>
  <v-row align="center" justify="center" class="pb-8">
    <MessageBox :message="messageBox.message" 
      :type="messageBox.tipoIcono" 
      :show="messageBox.mensajeVisible" 
      @closing="messageBox.mensajeVisible=false" />
    <v-col class="text-center px-5 py-3" cols="12" sm="6" md="4">
      <div class="mb-6">
        <v-btn
          icon
          title="Inicio de Sesión con Token"
          aria-label="Inicio de Sesión con Token"
          @click="goToSignin"
        >
          <v-icon size="60">far fa-user-circle</v-icon>
        </v-btn>
      </div>
      <span class="font-weight-bold leading--text" style="font-size: 32px"
        >Autenticación Token</span
      >

      <div class="mt-5">
        <!-- <v-form ref="form" v-model="valid"> -->
        <v-form ref="form">
          <v-col class="text-left">
            <!-- <span class="font-weight-bold">Nombre</span>
            <v-text-field
              outlined
              v-model="datos.usuario"
              placeholder="Ingrese un email válido"
              :rules="[rules.required, rules.email]"
              required
              class="mt-2"
            ></v-text-field> -->
            <v-text-field
              v-model.trim="datos.usuario"
              label = "Usuario"
              hint="Ingrese un email válido"
              :rules="[rules.required, rules.email]"
              required
              class="mt-2"
            ></v-text-field>
          </v-col>
          <v-row class="d-flex justify-center">
              <v-btn
                color="primary"
                @click="solicitarToken"
                :disabled="!conUsuario"
                :loading="loadingToken"
                width="200"
                class="mx-2 font-weight-bold"
                aria-label="Solicitar Token"
                >Solicitar Token</v-btn
              >
              <!-- <v-spacer></v-spacer> -->
              <v-btn
                color="primary"
                @click="registroUsuario"
                :disabled="!conUsuario"
                :loading="loadingRegistro"
                class="mx-2 font-weight-bold"
                width="200"
                aria-label="Registro de Usuario"
                >Registro de Usuario</v-btn
              >
          </v-row>
          <v-col class="text-left ">
            <!-- <span class="font-weight-bold elevation-0">Contraseña</span>
            <v-text-field
              outlined
              v-model="datos.token"
              required
              :append-icon="show1 ? 'far fa-eye' : 'far fa-eye-slash'"
              :rules="[rules.required]"
              :type="show1 ? 'text' : 'token'"
              @click:append="show1 = !show1"
              class="mt-2"
            ></v-text-field> -->
            <v-text-field
              v-model="datos.token"
              :disabled="!conUsuario"
              required
              label = "Token"
              hint="Ingrese token enviado al email"
              :append-icon="show1 ? 'far fa-eye' : 'far fa-eye-slash'"
              :rules="[rules.required]"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              class="mt-2"
            ></v-text-field>
          </v-col>
        </v-form>
        <div class="mt-5">
          <v-btn
            color="primary"
            @click="loginToken"
            :disabled="!conToken"
            :loading="loading"
            class="mx-2 font-weight-bold"
            width="200"
            aria-label="Iniciar sesión"
            >Aceptar</v-btn
          >
            <!-- <v-btn
              :class="
                `${$vuetify.breakpoint.xs ? 'mt-4 ' : ' '} mx-2 font-weight-bold`
              "
              width="200"
              color="grey"
              @click="test"
              aria-label="Test cambios"
              >Test</v-btn
            >           -->
        </div>
      </div>
    </v-col>
  </v-row>
</template>
<script>
import axios from "@/config/axios";
import jwt_decode from "jwt-decode";
import MessageBox from "@/components/MessageBox.vue"

import {mapState, mapMutations, mapActions} from 'vuex'
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
  components:{
    MessageBox
  },
  data: () => ({
    messageBox: {
      message: '',
      tipoIcono:'info',
      mensajeVisible: false,
    },
    loading: false,
    loadingToken: false,
    loadingRegistro: false,
    valid: true,
    // Si est token para registro o ingreso
    esTokenRegistro: false,
    rules: {
      required: (value) => !!value || "*Campo de texto requerido.",
      email: (value) => {
        // // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Ingrese un email válido.";
      },
      emailMatch: () => "The email and token you entered don't match",
    },
    show1: false,
    datos: {
      usuario: "",
      token: "",
    },
    status: {
      loading: false,
      error: false,
      message: "",
    },
  }),
  methods: {
    ...mapMutations('acceso', ['setUsuarioConfig']),
    ...mapActions('acceso',[
      'fetchEntidades', 
      'fetchUsuarios',
      'fetchUsuario',
      'validarDominioEMail',
      'validarUsuario'
    ]),  
    ...mapActions('process',['showNotifier']),
    test(){
            this.$store.dispatch("process/showNotifier", {
              message: "Just do it!",
              type: "info",
        });              
    },
    goToSignin(){
      this.$router.push("/login/signin");      
    },
    async solicitarToken(){
      try{
        // Marcar tipo de ingreso como de token
        this.esTokenRegistro = true
        this.loadingToken = true

        // Extraer dominio
        const dominio = this.datos.usuario
          .substring(this.datos.usuario.indexOf('@')+1)
        
        // this.$store.dispatch('acceso/validarDominioEMail',dominio)
        await this.validarUsuario(this.datos.usuario)
        let validacionUsuario = this.validacionUsuario

          // // this.$store.state.acceso.validacionUsuario     

        console.log(validacionUsuario)
        
        // // // let message=''
        // // // let tipoIcono='info'
        // // // if (validacionUsuario.DominioValido===0){
        // // //   message=`El dominio: "${dominio}", no está habilitado para registro de usuarios, favor validar con su entidad o con el CSJ.`
        // // //   tipoIcono='warning'
        // // // }
        // // // else if (validacionUsuario.CantidadUsuarios 
        // // //     - validacionUsuario.CantidadUsuariosActivos <=0) {
        // // //   message=`El dominio: "${dominio}", ya no cuenta con cupos disponibles para activar un nuevo usuario, favor validar con su entidad o con el CSJ.`
        // // //   tipoIcono='warning'
        // // // }
        // // // else{
        // // //   message=`Se ha enviado Token al email especificado, favor consultarlo e ingresarlo para continuar.`
        // // //   tipoIcono='success'
        // // // }
        // // this.mostrarMensaje(message, tipoIcono)
        this.showNotifier({
          message: "Se ha enviado Token al email especificado, favor consultarlo e ingresarlo para continuar.",
          type: 'success'
        });

      }catch(ex){
        // // alert(ex)
        // this.mostrarMensaje(ex, 'error')
        
        this.showNotifier({
          error: ex
        });
      }finally{
        this.loadingToken = false
      }

    },


    async registroUsuario(){
      try{
        // Marcar tipo de ingreso como de registro
        this.esTokenRegistro = false
        this.loadingRegistro = true

        // Extraer dominio
        const dominio = this.datos.usuario
          .substring(this.datos.usuario.indexOf('@')+1)

        // this.$store.dispatch('acceso/validarDominioEMail',dominio)
        await this.validarDominioEMail(this.datos.usuario)
        let validacionDominio = this.validacionDominio
          // // this.$store.state.acceso.validacionDominio     

        console.log(validacionDominio)

        // // // let message=''
        // // // let tipoIcono='info'
        // // // if (validacionDominio.DominioValido===0){
        // // //   message=`El dominio: "${dominio}", no está habilitado para registro de usuarios, favor validar con su entidad o con el CSJ.`
        // // //   tipoIcono='warning'
        // // // }
        // // // else if (validacionDominio.CantidadUsuarios 
        // // //     - validacionDominio.CantidadUsuariosActivos <=0) {
        // // //   message=`El dominio: "${dominio}", ya no cuenta con cupos disponibles para activar un nuevo usuario, favor validar con su entidad o con el CSJ.`
        // // //   tipoIcono='warning'
        // // // }
        // // // else{
        // // //   message=`Se ha enviado Token al email especificado, favor consultarlo e ingresarlo para continuar.`
        // // //   tipoIcono='success'
        // // // }
        // // // this.mostrarMensaje(message, tipoIcono)
        this.showNotifier({
          message: "Se ha enviado Token al email especificado, favor consultarlo e ingresarlo para continuar.",
          type: 'success'
        });
      }catch(err){
        // alert(ex)
        // // // this.mostrarMensaje(ex.message, 'error')
        this.showNotifier({
          error: err
        });	        
      }finally{
        this.loadingRegistro=false
      }
    },

  async loginToken() {
      // Si los campos son válidos
      if (this.$refs.form.validate()) {
        this.status.loading = true;
        
        await axios
          .post(
            '/LoginToken',
            {
                usuario: this.datos.usuario,
                password: this.datos.token
            }
          )
          .then((res) => {
            let user = jwt_decode(res.data.token);
            user.jwt = res.data.token;

            this.$store.commit("auth/SET_AUTH_USER", user);
            
            // Si se está ingresando con Token
            if(this.esTokenRegistro){
              this.$router.push("/");
            // Si se está ingresando a registro de usuario
            }else{
              // // let usuarioConfig = this.usuarioConfig
              // // // const usuarios = this.getUsuarios
              // // // const indiceUsuario = usuarios.findIndex(e=>e.idUsuario===id)

              // Extraer los datos del usuario
              this.setUsuarioConfig({
                email: this.datos.usuario,
                esNuevoEditar: !this.validacionDominio.UsuarioExistente,
                desdeListado: false,
                indiceListado: -1
              })

              /*  Cargar el usuario antes de pasar a la visata de usuario.
                  de tal forma que si no puede cargar por alguna razón no quede 
                  en la vista de usuario, donde ya estaría autenticado... */ 
              // // // await this.fetchUsuario(this.datos.usuario)
              // // // 
              // // // console.log("this.usuario - Antes de Editar Registro", this.usuario)
              // // // this.$router.push({name:'MainAccesoUsuario'})
              this.fetchUsuario(this.datos.usuario)
              .then((res)=>{
                  
                  console.log("this.usuario - Antes de Editar Registro", this.usuario)
                  
                  this.$router.push({name:'MainAccesoUsuario'})
                }  
               )
            }
          })
          .catch((err) => {
            // // // this.$store.dispatch("process/showNotifier", {
            // // //   error: err
            // // // });
            this.showNotifier({
              error: err
            });
          })
          .finally((this.loading = false));
      }
    },
  },
  computed:{
    ...mapState('acceso',['validacionDominio', 'validacionUsuario']),
    conUsuario(){
      // // return (this.datos.usuario??'').includes('@')
      return pattern.test(this.datos.usuario??'')
    },
    conToken(){
      return (this.datos.token??'').length===6
    }
  }
};
</script>
<style scoped>
/* >>> .v-messages {
  margin-left: -8px !important;
} */

>>> .v-icon.v-icon {
  font-size: 13px;
}
</style>
